import React, { Component } from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import s from './DetailsRow.css'

library.add(faExternalLinkAlt)

class DetailsRow extends Component {
  formatPercent(number) {
    return number !== null && isNaN(number) === false ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
  }
  formatDecimal(number) {
    return number !== null ? parseFloat(number).toFixed(2) : '-'
  }
  formatNumber(number) {
    return number !== null ? parseFloat(number).toFixed(0) : '-'
  }
  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }

  render() {
    const { type, data } = this.props

    if (type === 'stdPerformance') {
      return (
        <tr>
          <td className={s.textCenter}>
            {data.entityName} {data.relatedType.substring(0, 3) == 'NAV' ? ' (NAV)' : ' (PRICE) '}
          </td>
          <td className={s.textCenter}>{data.entityID}</td>
          <td className={s.textCenter}>{this.formatPercent(data.expenseRatio)}</td>
          <td className={s.textCenter}>{this.formatDate(data.inceptionDt)}</td>
          <td className={s.textCenter}>{this.formatPercent(data.trailing01yearsRor)}</td>
          <td className={s.textCenter}>{this.formatPercent(data.trailing03yearsRor)}</td>
          <td className={s.textCenter}>{this.formatPercent(data.trailing05yearsRor)}</td>
          <td className={s.textCenter}>{this.formatPercent(data.trailing10yearsRor)}</td>
          <td className={s.textCenter}>{this.formatPercent(data.rorCumAnn)}</td>
        </tr>
      )
    }

    if (type === 'fund-underlying') {
      return (
        <tr>
          {data.entities === 'GTRExP' || data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={s.textCenter}> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {data.nameCollapse} </td> : <td className={s.textCenter}> {data.nameCollapse}</td>}
          {data.entities === 'GTRExP' || data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={s.textCenter}>{'--'}</td> : <td className={s.textCenter}>{data.entities}</td>}
          {data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={data.wks1RoR < 0 ? 'red' : data.wks1RoR > 0 ? 'green' : s.textCenter}> {this.formatPercent(data.wks1RoR)}</td> : <td className={s.textCenter}> {this.formatPercent(data.wks1RoR)} </td>}
          {data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={data.mtd < 0 ? 'red' : data.mtd > 0 ? 'green' : s.textCenter}> {this.formatPercent(data.mtd)}</td> : <td className={s.textCenter}> {this.formatPercent(data.mtd)} </td>}
          {data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={data.mos1RoR < 0 ? 'red' : data.mos1RoR > 0 ? 'green' : s.textCenter}> {this.formatPercent(data.mos1RoR)}</td> : <td className={s.textCenter}> {this.formatPercent(data.mos1RoR)} </td>}

          {data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={data.mos3RoR < 0 ? 'red' : data.mos3RoR > 0 ? 'green' : s.textCenter}> {this.formatPercent(data.mos3RoR)}</td> : <td className={s.textCenter}> {this.formatPercent(data.mos3RoR)} </td>}

          {data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={data.ytd < 0 ? 'red' : data.ytd > 0 ? 'green' : s.textCenter}> {this.formatPercent(data.ytd)}</td> : <td className={s.textCenter}> {this.formatPercent(data.ytd)} </td>}

          {data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={data.sinceFundInceptionOptionRoll < 0 ? 'red' : data.sinceFundInceptionOptionRoll > 0 ? 'green' : s.textCenter}> {this.formatPercent(data.sinceFundInceptionOptionRoll)}</td> : <td className={s.textCenter}> {this.formatPercent(data.sinceFundInceptionOptionRoll)} </td>}

          {data.entities === 'GTRRelWT' || data.entities === 'GTRRelExt' ? <td className={data.sinceFundInception < 0 ? 'red' : data.sinceFundInception > 0 ? 'green' : s.textCenter}> {this.formatPercent(data.sinceFundInception)}</td> : <td className={s.textCenter}> {this.formatPercent(data.sinceFundInception)} </td>}
        </tr>
      )
    }

    if (type === 'optionDetails') {
      return (
        <tr>
          {data.lsCall !== 'Short Call' ? <td className={s.textCenter}>{this.formatDecimal(data.contributorWeight) * 100}%</td> : <td className={s.textCenter}></td>}
          {data.lsCall !== 'Short Call' ? <td className={s.textCenter}> {data.underlyingTicker}</td> : <td className={s.textCenter}></td>}
          {data.lsCall !== 'Short Call' ? (
            <td width='150' className={s.textCenter}>
              {' '}
              {this.formatDecimal(data.etfNAVLastCOB)}{' '}
            </td>
          ) : (
            <td className={s.textCenter}></td>
          )}
          {data.lsCall !== 'Short Call' ? (
            <td width='150' className={s.textCenter}>
              {' '}
              {this.formatDecimal(data.etfNAVatRoll)}{' '}
            </td>
          ) : (
            <td className={s.textCenter}></td>
          )}
          {data.lsCall !== 'Short Call' ? <td className={s.textCenter}> {this.formatPercent(data.etfNavDeltaPct)} </td> : <td className={s.textCenter}></td>}
          <td width='145' className={s.textCenter}>
            {data.lsCall}
          </td>
          {isNaN(this.formatNumber(data.crnt_strike_prc)) ? <td width='170' className={s.textCenter}></td> : <td className={s.textCenter}>{this.formatNumber(data.crnt_strike_prc)} </td>}
          {isNaN(this.formatNumber(data.crnt_strike_prc)) ? <td width='170' className={s.textCenter}></td> : <td className={s.textCenter}>{this.formatDecimal(data.optionPriceAtRoll)} </td>}
          {isNaN(this.formatNumber(data.crnt_strike_prc)) ? <td width='125' className={s.textCenter}></td> : <td className={s.textCenter}> {this.formatDecimal(data.optionPrice)} </td>}

          <td width='170' className={s.textCenter}>
            {this.formatPercent(data.premiumPaidAtRollover)}
          </td>
          <td width='170' className={s.textCenter}>
            {this.formatPercent(data.optionValueToday)}
          </td>
          {/* <td  width='125' className={s.textCenter}>
          {this.formatPercent(data.intrinsicValue)}  
          </td>
          <td  width='125' className={s.textCenter}>
          {this.formatPercent(data.extrinsicValue)}  
          </td> */}
        </tr>
      )
    }
  }
}

export default DetailsRow



// WEBPACK FOOTER //
// ./src/components/App/DetailsTable/DetailsRow.js